import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FieldArrayWithId } from 'react-hook-form/dist/types/fieldArray';

import Box from '@mui/material/Box';

import { useFieldArrayContext } from 'components/shared/CRUD/components/InnerPage/hooks/useFieldArrayContext';
import useFindIndexFromFieldsArray from 'components/shared/CRUD/hooks/useFindIndexFromFieldsArray';
import {
  ControlledCheckbox,
  ControlledSelect
} from 'components/shared/ControlledFields';

const getLastAddedFieldId = (fields: FieldArrayWithId[]) =>
  fields.slice(-1)[0]?.id;

const EditDataPermission = ({ rowId, costCenterOptions }) => {
  const { control } = useFormContext();
  const { fields } = useFieldArrayContext();
  const fieldIndex = useFindIndexFromFieldsArray(
    rowId ?? getLastAddedFieldId(fields),
    fields
  );

  const isInEditMode = !!rowId;

  const { t } = useTranslation('common');

  return (
    <Box width={'100%'}>
      <Box mb={2.5} width={'100%'}>
        <ControlledSelect
          name={`costCenterGrants[${fieldIndex}].brId`}
          label={t('dataPermissions.planUnit')}
          disabled={isInEditMode}
          options={[
            { value: -1, label: t('allPlanUnits') },
            ...costCenterOptions
          ]}
          control={control}
        />
      </Box>
      <Box mb={2.5} width={'100%'}>
        <ControlledCheckbox
          name={`costCenterGrants[${fieldIndex}].approveHours`}
          control={control}
          label={t('dataPermissions.approveHours')}
        />
      </Box>
    </Box>
  );
};

export default EditDataPermission;
